import React, { useCallback, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";

import { getConversations } from "actions/getConversations";
import ChatItem from "../ChatItem";

import styles from "./styles.module.scss";

export default function ChatsList({ onChatClick, openedEmploeeId }) {
    const dispatch = useDispatch();
    const conversations = useSelector((state) => state.conversations.items);
    const lang = useSelector((state) => state.settings.lang);

    const loader = useRef(null);
    const isFirstTimeLoaded = useRef(false);
    const conversationsLength = useRef(conversations.length);

    const handleObserver = useCallback(
        (entries) => {
            const target = entries[0];
            if (target.isIntersecting) {
                dispatch(getConversations(lang, conversations.length));
                isFirstTimeLoaded.current = true;
                conversationsLength.current = conversations.length;
            }
        },
        [conversations.length, dispatch, lang],
    );

    useEffect(() => {
        const option = {
            root: null,
            rootMargin: "20px",
            threshold: 0,
        };
        const observer = new IntersectionObserver(handleObserver, option);

        if (
            loader.current &&
            (conversations.length > conversationsLength.current || !isFirstTimeLoaded.current)
        ) {
            observer.observe(loader.current);
        } else {
            observer.disconnect();
        }
        return () => observer.disconnect();
    }, [handleObserver, conversations]);

    return (
        <ul className={styles.chats}>
            {conversations.map((el, index) => (
                <ChatItem
                    conversation={el}
                    onChatClick={onChatClick}
                    key={index}
                    openedEmploeeId={openedEmploeeId}
                />
            ))}
            <li ref={loader} className={styles.contacts__end} />
        </ul>
    );
}
